import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37ec9eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-1" }, "Pilih Transaksi", -1))
const _hoisted_4 = { class: "flex justify-between items-center text-sm text-neutral-500" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Pilih transaksi yang akan Anda masukkan dalam batch ini.", -1))
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "flex flex-col md:flex-row justify-between items-center mb-6 gap-4" }
const _hoisted_8 = { class: "flex items-center gap-3 w-full md:w-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Filter:", -1))
const _hoisted_10 = { class: "relative w-full md:w-48" }
const _hoisted_11 = { class: "relative w-full md:w-80 input-icon-right" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-4"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-blue-500" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times text-xs" }, null, -1))
const _hoisted_16 = { class: "fuel-payment-batch-detail-table" }
const _hoisted_17 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "KODE", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "TANGGAL", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "POM", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "KRU - NOPOL", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "JENIS TRANSAKSI", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "LITER", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "NOMINAL", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "DETAIL", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "9",
    class: "text-center py-8"
  }, "Tidak ada data transaksi yang belum dibayar")
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = { class: "flex items-center justify-start gap-2 mb-1" }
const _hoisted_37 = { class: "text-xs" }
const _hoisted_38 = { class: "flex items-center justify-start gap-2" }
const _hoisted_39 = { class: "text-xs font-semibold" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-xs" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  class: "unpaid-footer bg-white border border-neutral-200 p-4 md:px-8 flex flex-col md:flex-row justify-between items-center gap-4 shadow-sm !rounded-t-none rounded-b-lg w-full",
  style: {"border-top-left-radius":"0 !important","border-top-right-radius":"0 !important"}
}
const _hoisted_47 = { class: "flex flex-col" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "text-lg font-bold text-blue-500" }
const _hoisted_50 = { class: "flex items-center gap-3 w-full md:w-auto" }

import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import FilterDropdown from '@/views/components/filter/FilterDropdown.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useUnpaidTransactions } from '@/composables/pages/externals/fuel-payment-batch/useUnpaidTransactions'
import { useBatchPaymentConfirm } from '@/composables/pages/externals/fuel-payment-batch/useBatchPaymentConfirm'
import { checkActionAllowedRoles } from '@/utils/helpers/checkActionAllowedRoles'
import BatchPaymentConfirmModal from '../components/BatchPaymentConfirmModal.vue'
import '../detail-table.scss'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnpaidList',
  emits: ['onSuccessBatch'],
  setup(__props, { emit }) {

const store = useStore()
const router = useRouter()
const isMounted = ref(false)

const isSidebarOpen = computed(() => store.state.ui.sideBarActive)
const isAllowedToCreateBatch = computed(() => checkActionAllowedRoles(['Admin', 'Keuangan']))

const {
  filterDate,
  searchQuery,
  dataSource,
  lastUpdated,
  selectedTransactionIds,
  appliedPartnerIds,
  appliedTransactionTypes,
  partnerOptions,
  transactionTypeOptions,
  fetchData,
  activeFilters,
  removeFilter,
  clearAllFilters,
  toggleSelectTransaction,
  toggleSelectAll,
  isAllSelected,
  selectedCount,
  selectedTotalAmount,
  resetSelection
} = useUnpaidTransactions()

const mappedPartnerOptions = computed(() => partnerOptions.value.map((item: any) => ({
  value: item.Id,
  label: item.Name
})))

const mappedTransactionTypeOptions = computed(() => transactionTypeOptions.value.map((item: any) => ({
  value: item.Name,
  label: item.Description
})))

const {
  isModalOpen,
  isLoadingPartnerSummary,
  isSubmitting,
  partnerSummary,
  grandTotal,
  openConfirmModal,
  closeConfirmModal,
  submitBatch
} = useBatchPaymentConfirm(dataSource, selectedTransactionIds)

/* global defineEmits */


const getTransactionTypeLabel = (type?: string) => {
  if (!type) return '-'
  const matched = transactionTypeOptions.value?.find(
    (item: any) => item.Name === type || item.Name?.toLowerCase() === type.toLowerCase()
  )
  return matched?.Description || type
}

const openDetail = (item: any) => {
  router.push({
    name: 'fuel-payment-batch-transaction-detail',
    params: { id: encryptDecriptMethods.encrypt({ Id: item.Id }) }
  })
}

const showConfirmBatch = () => {
  openConfirmModal()
}

const onSubmitBatch = async () => {
  const success = await submitBatch()
  if (success) {
    resetSelection()
    fetchData()
    emit('onSuccessBatch')
  }
}

onMounted(() => {
  store.dispatch('ui/setBreadcrumbs', [])
  isMounted.value = true
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, "Terakhir Diupdate: " + _toDisplayString(_unref(lastUpdated) || '-'), 1),
          _createElementVNode("i", {
            class: "pi pi-sync cursor-pointer text-blue-500 hover:text-blue-600",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(fetchData) && _unref(fetchData)(...args)))
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(Calendar), {
            modelValue: _unref(filterDate),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterDate) ? (filterDate).value = $event : null)),
            selectionMode: "range",
            dateFormat: "dd/mm/yy",
            placeholder: "Tanggal",
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(FilterDropdown, {
          label: "Nama Pom",
          title: "Filter Nama Pom",
          options: _unref(mappedPartnerOptions),
          modelValue: _unref(appliedPartnerIds),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(appliedPartnerIds) ? (appliedPartnerIds).value = $event : null)),
          onApply: _unref(fetchData),
          onReset: _unref(fetchData)
        }, null, 8, ["options", "modelValue", "onApply", "onReset"]),
        _createVNode(FilterDropdown, {
          label: "Jenis Transaksi",
          title: "Filter Jenis Transaksi",
          options: _unref(mappedTransactionTypeOptions),
          modelValue: _unref(appliedTransactionTypes),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(appliedTransactionTypes) ? (appliedTransactionTypes).value = $event : null)),
          onApply: _unref(fetchData),
          onReset: _unref(fetchData)
        }, null, 8, ["options", "modelValue", "onApply", "onReset"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(InputText), {
          modelValue: _unref(searchQuery),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
          placeholder: "Cari kode transaksi",
          class: "w-full input-default",
          onKeyup: _withKeys(_unref(fetchData), ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createElementVNode("i", {
          class: "pi pi-search text-neutral-400 cursor-pointer",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(fetchData) && _unref(fetchData)(...args)))
        })
      ])
    ]),
    (_unref(activeFilters).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeFilters), (pill) => {
            return (_openBlock(), _createElementBlock("div", {
              key: pill.id,
              class: "border border-blue-500 bg-blue-50 hover:bg-blue-100 rounded-full px-4 py-2 text-sm flex items-center gap-2 font-medium cursor-pointer transition-colors duration-150 text-blue-500",
              onClick: ($event: any) => (_unref(removeFilter)(pill))
            }, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(pill.label), 1),
              _hoisted_15
            ], 8, _hoisted_13))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("table", _hoisted_17, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: _normalizeClass(["text-xs text-center w-10", { 'cursor-not-allowed': !_unref(isAllowedToCreateBatch) }]),
              title: !_unref(isAllowedToCreateBatch) ? 'Anda tidak memiliki akses untuk membuat batch' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'pointer-events-none': !_unref(isAllowedToCreateBatch) })
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: _unref(isAllSelected),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(isAllowedToCreateBatch) ? _unref(toggleSelectAll)() : null)),
                  disabled: !_unref(isAllowedToCreateBatch),
                  binary: true
                }, null, 8, ["modelValue", "disabled"])
              ], 2)
            ], 10, _hoisted_18),
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _hoisted_26
          ])
        ]),
        (_unref(dataSource).length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, _hoisted_29))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: data.Id,
                  class: _normalizeClass(["transition-colors", [data.ApprovalStatus === 'Submitted' ? 'bg-neutral-300 text-neutral-500' : 'hover:bg-neutral-50']])
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-center", { 'cursor-not-allowed': !_unref(isAllowedToCreateBatch) }]),
                    title: !_unref(isAllowedToCreateBatch) ? 'Anda tidak memiliki akses untuk membuat batch' : ''
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'pointer-events-none': !_unref(isAllowedToCreateBatch) })
                    }, [
                      _createVNode(_unref(Checkbox), {
                        modelValue: _unref(selectedTransactionIds).has(data.Id),
                        onClick: ($event: any) => (data.ApprovalStatus === 'Waiting' && _unref(isAllowedToCreateBatch) ? _unref(toggleSelectTransaction)(data.Id) : null),
                        disabled: data.ApprovalStatus === 'Submitted' || !_unref(isAllowedToCreateBatch),
                        binary: true
                      }, null, 8, ["modelValue", "onClick", "disabled"])
                    ], 2)
                  ], 10, _hoisted_31),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(data.Code ?? '-'), 1),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(data.CreatedAt ? _unref(moment)(data.CreatedAt).format('DD/MM/YYYY') : '-'), 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(data.FuelStationPartnerName ?? '-'), 1),
                  _createElementVNode("td", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["pi pi-user text-xs", data.ApprovalStatus === 'Submitted' ? 'text-neutral-500' : 'text-grey'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(data.CrewName ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["pi pi-id-card text-xs", data.ApprovalStatus === 'Submitted' ? 'text-neutral-500' : 'text-blue-500'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(data.VehicleRegNumber ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(getTransactionTypeLabel(data.TransactionType)), 1),
                    (data.FuelTransactionVoucher)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["text-xs", data.ApprovalStatus === 'Submitted' ? 'text-neutral-500' : 'text-blue-500'])
                        }, _toDisplayString(data.FuelTransactionVoucher.Code), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_42, _toDisplayString(data.Liters ? `${_unref(numberFormat)(data.Liters)} L` : '-'), 1),
                  _createElementVNode("td", _hoisted_43, _toDisplayString(_unref(rupiahFormat)(data.Price ?? 0)), 1),
                  _createElementVNode("td", _hoisted_44, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["cursor-pointer text-xs hover:underline", data.ApprovalStatus === 'Submitted' ? 'text-neutral-500' : 'text-blue-500']),
                      onClick: ($event: any) => (openDetail(data))
                    }, "Lihat Detail >", 10, _hoisted_45)
                  ])
                ], 2))
              }), 128))
            ]))
      ])
    ]),
    _createVNode(BatchPaymentConfirmModal, {
      show: _unref(isModalOpen),
      partnerSummary: _unref(partnerSummary),
      grandTotal: _unref(grandTotal),
      isLoading: _unref(isLoadingPartnerSummary),
      isSubmitting: _unref(isSubmitting),
      onHideDialog: _unref(closeConfirmModal),
      onOnSubmit: onSubmitBatch
    }, null, 8, ["show", "partnerSummary", "grandTotal", "isLoading", "isSubmitting", "onHideDialog"]),
    (isMounted.value && _unref(isAllowedToCreateBatch))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#unpaid-footer-container"
        }, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-sm font-medium transition-colors", _unref(selectedCount) > 0 ? 'text-blue-500 cursor-pointer hover:underline' : 'text-neutral-600']),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(selectedCount) > 0 ? _unref(clearAllFilters)() : null)),
                title: _unref(selectedCount) > 0 ? 'Klik untuk menampilkan semua data (hapus semua filter)' : ''
              }, _toDisplayString(_unref(selectedCount)) + " transaksi dipilih ", 11, _hoisted_48),
              _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(rupiahFormat)(_unref(selectedTotalAmount))), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_unref(Button), {
                label: "Reset",
                class: "p-button-outlined text-neutral-700 border-neutral-300 w-full md:w-32 justify-center",
                onClick: _unref(resetSelection)
              }, null, 8, ["onClick"]),
              _createVNode(_unref(Button), {
                label: "Buat Batch",
                class: "bg-blue-500 border-blue-500 text-white w-full md:w-40 justify-center",
                disabled: _unref(selectedCount) === 0,
                onClick: showConfirmBatch
              }, null, 8, ["disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})